import { AxiosResponse } from 'axios';
import { SET_ATTENDANCE_SHIFTS, SET_ATTENDANCE_SHIFT, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_ATTENDANCE_SHIFT_ISLOADING,
  DELETE_ATTENDANCE_SHIFT,
  EDIT_ATTENDANCE_SHIFT,
  GET_ATTENDANCE_SHIFTS,
  GET_ATTENDANCE_SHIFT,
  REGISTER_ATTENDANCE_SHIFT,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import AttendanceShift from '@/services/attendance_shift';
import { Module } from 'vuex';
import { EditAttendanceShift, RegisterAttendanceShift, GetAttendanceShift } from '@/dtos/attendance_shift.dto';

const attendanceShift: Module<any, {}> = {
  state: {
    attendanceShift: {
      data: null,
      isLoading: false,
    },
    attendanceShifts: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    attendanceShift: (state: { attendanceShift: any }) => state.attendanceShift,
    attendanceShifts: (state: { attendanceShifts: any }) => state.attendanceShifts,
  },
  mutations: {
    [SET_ATTENDANCE_SHIFT]: (
      state: { attendanceShift: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.attendanceShift.data = payload.data) : null,
        (state.attendanceShift.isLoading = payload.isLoading);
    },
    [SET_ATTENDANCE_SHIFTS]: (
      state: { attendanceShifts: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.attendanceShifts.data = payload.data) : null,
        (state.attendanceShifts.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_ATTENDANCE_SHIFT]: async ({ commit }: any, payload: any) => {
      commit(SET_ATTENDANCE_SHIFT, { data: null, isLoading: true });

      const result: AxiosResponse = await AttendanceShift.registerAttendanceShift(
        payload as RegisterAttendanceShift
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ATTENDANCE_SHIFT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ATTENDANCE_SHIFT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ATTENDANCE_SHIFT, { isLoading: false });
        return false;
      }
    },
    [GET_ATTENDANCE_SHIFTS]: async ({ commit }: any, payload: any) => {
      commit(SET_ATTENDANCE_SHIFTS, { data: null, isLoading: true });

      const result: AxiosResponse = await AttendanceShift.getAttendanceShifts(
        payload as GetAttendanceShift
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ATTENDANCE_SHIFTS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ATTENDANCE_SHIFTS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ATTENDANCE_SHIFTS, { isLoading: false });
        return false;
      }
    },
    [GET_ATTENDANCE_SHIFT]: async ({ commit }: any, payload: any) => {
      commit(SET_ATTENDANCE_SHIFT, { data: null, isLoading: true });

      const result: AxiosResponse = await AttendanceShift.getAttendanceShifts(
        payload as GetAttendanceShift
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ATTENDANCE_SHIFT, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_ATTENDANCE_SHIFT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ATTENDANCE_SHIFT, { isLoading: false });
        return false;
      }
    },
    [EDIT_ATTENDANCE_SHIFT]: async ({ commit }: any, payload: any) => {
      commit(SET_ATTENDANCE_SHIFT, { data: null, isLoading: true });

      const result: AxiosResponse = await AttendanceShift.editAttendanceShift(
        payload as EditAttendanceShift
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ATTENDANCE_SHIFT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ATTENDANCE_SHIFT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ATTENDANCE_SHIFT, { isLoading: false });
        return false;
      }
    },
    [DELETE_ATTENDANCE_SHIFT]: async ({ commit }: any, payload: string) => {
      commit(SET_ATTENDANCE_SHIFT, { data: null, isLoading: true });

      const result: AxiosResponse = await AttendanceShift.deleteAttendanceShift(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ATTENDANCE_SHIFT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ATTENDANCE_SHIFT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ATTENDANCE_SHIFT, { isLoading: false });
        return false;
      }
    },
    [CLEAR_ATTENDANCE_SHIFT_ISLOADING]: ({ commit }) => {
      commit(SET_ATTENDANCE_SHIFT, { isLoading: false });
      commit(SET_ATTENDANCE_SHIFTS, { isLoading: false });
    },
  },
};

export default attendanceShift;
